import React from 'react';
import { Link } from 'react-router-dom';
import { GROUP } from '../CompanyInfo';
import './BrandHeader.css';

/**
 * The brand band shared by the product pages, both logins and the customer
 * area. Each of those built its own copy from App.css's .product_header / #S
 * / .R, which floated the partner logo with a negative margin and forced the
 * square brand mark to 70x80 - the reason those headers looked misaligned.
 *
 * `to` is where the logo and the name link. It defaults to the public landing
 * page, but inside the customer area it points at the order screen so the
 * header does not drop a signed-in customer back onto the public site.
 */
// `badge`: optional label in the right-hand cell - the Shimoga section uses it
// to show which branch is signed in. Nothing renders without it.
const BrandHeader = ({ to = '/', badge = null }) => (
    <header className='brandHeader'>
        {/* Logo stays on the left where it was; only the name is centred, so
            it needs its own grid cell between two equal-width outer cells. */}
        <Link to={to} className='brandLogoLink'>
            <img src={GROUP.logo} className='brandLogo' alt={GROUP.name} />
        </Link>

        <Link to={to} className='brandHeaderMain'>
            <span>
                <h1 className='brandName'>{GROUP.name}</h1>
                <p className='brandSince'>{GROUP.since}</p>
            </span>
        </Link>

        {/* The Reliable Software mark lives in the footer on every page that
            uses this band, so it is not repeated up here. */}
        {badge ? <span className='brandBadge'>{badge}</span> : null}
    </header>
);

export default BrandHeader;
